<template>
  <el-dialog
    :title="isUpdate ? '修改群组' : '添加群组'"
    :visible="visible"
    width="560px"
    :destroy-on-close="true"
    :lock-scroll="false"
    custom-class="ele-dialog-form"
    append-to-body
    @update:visible="updateVisible">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="财务名称:" prop="finance_id">
        <el-select
          multiple
          filterable
          clearable
          class="ele-fluid"
          v-model="form.finance_id"
          placeholder="请选择">
          <el-option v-for="item in financeList" :key="item.id" :value="item.id" :label="item.username" />
        </el-select>
      </el-form-item>
      <el-form-item label="小组名称:" prop="classname">
        <el-input clearable :maxlength="20" v-model.trim="form.classname" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="货币国家:" prop="country_id">
        <el-select
          clearable
          filterable
          class="ele-fluid"
          v-model="form.country_id"
          placeholder="请选择"
          :loading="countryLoading">
          <el-option v-for="item in countryList" :key="item.id" :value="item.id" :label="item.name" />
        </el-select>
      </el-form-item>
      <el-form-item label="渠道类型:" prop="type_code">
        <el-select clearable filterable class="ele-fluid" v-model="form.type_code" placeholder="请选择">
          <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="updateVisible(false)">取消</el-button>
      <el-button type="primary" :loading="loading" @click="save">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getDictData } from '@/utils/dict';

const defaultForm = () => ({
  status: 1,
  finance_id: [],
  classname: '',
  country_id: '',
  type_code: ''
});

const parseFinanceIds = (value) => {
  if (Array.isArray(value)) {
    return value.map((id) => Number(id)).filter((id) => id > 0);
  }
  if (value === null || value === undefined || value === '' || value === 0 || value === '0') {
    return [];
  }
  return String(value)
    .split(',')
    .map((id) => Number(String(id).trim()))
    .filter((id) => id > 0);
};

export default {
  name: 'ReclassEdit',
  props: {
    visible: Boolean,
    data: Object
  },
  data() {
    return {
      form: defaultForm(),
      rules: {
        classname: [{ required: true, message: '请输入', trigger: 'blur' }],
        finance_id: [{ type: 'array', required: true, min: 1, message: '请选择', trigger: 'change' }],
        country_id: [{ required: true, message: '请选择', trigger: 'change' }],
        type_code: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      loading: false,
      isUpdate: false,
      financeList: [],
      countryList: [],
      countryLoading: false,
      typeOptions: []
    };
  },
  watch: {
    data() {
      this.initForm();
    },
    visible(val) {
      if (val) {
        this.initForm();
        if (!this.typeOptions.length) {
          this.loadTypeOptions();
        }
        this.queryCountryList();
      }
    }
  },
  mounted() {
    this.queryFinance();
    this.loadTypeOptions();
  },
  methods: {
    initForm() {
      if (this.data && Object.keys(this.data).length) {
        this.form = Object.assign(defaultForm(), {
          id: this.data.id,
          status: this.data.status || 1,
          finance_id: parseFinanceIds(this.data.finance_id),
          classname: this.data.classname,
          country_id: this.data.country_id || this.data.cny_id,
          type_code: this.data.type_code
        });
        this.isUpdate = true;
      } else {
        this.form = defaultForm();
        this.isUpdate = false;
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return false;
        }
        this.loading = true;
        const payload = {
          id: this.form.id,
          status: this.form.status || 1,
          classname: this.form.classname,
          country_id: this.form.country_id,
          type_code: this.form.type_code,
          finance_id: (this.form.finance_id || []).join(',')
        };
        this.$http.post('/resourceclass/editTo', payload).then((res) => {
          this.loading = false;
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.updateVisible(false);
            this.$emit('done');
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch((e) => {
          this.loading = false;
          this.$message.error(e.message);
        });
      });
    },
    updateVisible(value) {
      this.$emit('update:visible', value);
    },
    queryFinance() {
      this.$http.get('/Finance/getFinanceList').then((res) => {
        if (res.data.code === 0) {
          this.financeList = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        this.$message.error(e.message);
      });
    },
    queryCountryList() {
      if (this.countryList.length) {
        return;
      }
      this.countryLoading = true;
      this.$http.get('/CountryRegion/getCountryRegionList').then((res) => {
        this.countryLoading = false;
        if (res.data.code === 0) {
          this.countryList = res.data.data || [];
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        this.countryLoading = false;
        this.$message.error(e.message);
      });
    },
    loadTypeOptions() {
      getDictData('type_name')
        .then((list) => {
          this.typeOptions = (list || []).map((item) => ({
            value: item.dictDataCode,
            label: item.dictDataName
          }));
        })
        .catch((e) => {
          this.$message.error(e.message);
        });
    }
  }
};
</script>
